import React from 'react';

import { type NativeMethods } from 'react-native/types';

type PropsWithCopilot<P> = P & {
  copilot: {
    ref?: React.Ref<any>;
    onLayout?: () => void;
  };
};

export function walkthroughable<P = any>(
  WrappedComponent: React.ComponentType<P>
) {
  // Forward the ref!
  const Component = React.forwardRef<any, PropsWithCopilot<P>>(({ copilot, ...props }, ref) => {
    // Use the copilot.ref if provided, otherwise use the forwarded ref
    return <WrappedComponent ref={copilot?.ref || ref} {...(copilot as any)} {...props} />;
  });

  return Component;
}
